import type { IdentityId } from "@/types/navigation";

export type IdentityCardData = {
  id: Exclude<IdentityId, "other">;
  title: string;
  sub: string;
  tone: "forest" | "terra" | "gold" | "cream";
};

export const IDENTITY_CARDS: IdentityCardData[] = [
  {
    id: "solo",
    title: "独自来读书,想一个人住",
    sub: "安静、独立,自己的节奏。",
    tone: "forest",
  },
  {
    id: "share",
    title: "想找人合租,搭伴又省钱",
    sub: "热闹、互相照应,预算更轻。",
    tone: "terra",
  },
  {
    id: "parent",
    title: "家长,替孩子安排住处",
    sub: "替孩子把关,远程也能放心。",
    tone: "gold",
  },
  {
    id: "switch",
    title: "已经在新加坡,需要换房",
    sub: "对当地有概念,只差更合适的下一个家。",
    tone: "cream",
  },
];
